import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faAward, faMedal, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import educationData from "../data/education.json";
import "../styles/education.css";

const Education = () => {
  return (
    <div className="edu-section">
      <div className="edu-header">
        <FontAwesomeIcon icon={faGraduationCap} className="edu-main-icon" />
        <h2 className="edu-main-title">Education</h2>
        <p className="edu-main-description">
          My academic journey with degrees earned and humble experience
        </p>
      </div>
      
      <div className="edu-cards">
        {educationData.map((edu) => (
          <div key={edu.id} className="edu-card">
            <div className="edu-card-header">
              <img 
                src={edu.universityLogo} 
                alt={edu.institution} 
                className="edu-logo" 
              />
              <div className="edu-header-text">
                <h3>
                  <a 
                    href={edu.website} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="institution-name"
                  >
                    {edu.institution}
                    <FontAwesomeIcon icon={faExternalLinkAlt} className="external-link-icon" />
                  </a>
                </h3>
                <p className="edu-period">{edu.year}</p>
              </div>
            </div>
            
            <div className="edu-card-body">
              <div className="edu-degree-info">
                <p className="edu-degree">{edu.degree}</p>
                <p className="edu-grade">Score/GPA: {edu.grade}</p>
              </div>
              
              {edu.honors && (
                <div className="edu-honors">
                  <div className="honors-title">
                    <FontAwesomeIcon icon={faAward} className="honor-icon" />
                    <span>Key Achievements</span>
                  </div>
                  <div className="honors-list">
                    {edu.honors.map((honor, i) => (
                      <div key={i} className="honor-item">
                        <FontAwesomeIcon icon={faMedal} className="medal-icon" />
                        <span className="honor-text">{honor}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;